var React = require('react');

function Play (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M49.8525 33.5508L29.1883 19.2462C27.8967 18.4659 26.0886 19.2462 26.0886 20.8067V49.4159C26.0886 51.2365 27.8967 51.7567 29.1883 50.9764L49.8525 36.9319C51.144 36.1516 51.144 34.331 49.8525 33.5508Z","key":0}),React.createElement("path",{"d":"M34.8708 0C54.2435 0 70 15.8651 70 35.1113C70 54.6176 54.2435 70.4828 34.8708 70.4828C15.7565 70.4828 0 54.6176 0 35.1113C0 15.8651 15.7565 0 34.8708 0ZM34.8708 4.68151C18.0812 4.68151 4.64945 18.2059 4.64945 35.1113C4.64945 52.0168 18.0812 65.8012 34.8708 65.8012C51.6605 65.8012 65.3505 52.0168 65.3505 35.1113C65.3505 18.2059 51.6605 4.68151 34.8708 4.68151Z","key":1})]);
}

Play.defaultProps = {"width":"70","height":"71","viewBox":"0 0 70 71","className":"fill-current"};

module.exports = Play;

Play.default = Play;
